import React from 'react';
import { Card } from '../components/ui/card';
import { mockData } from '../data/mockData';

const ProcessSection = () => {
  return (
    <section id="process" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
              Our Trademark Registration Process
            </h2>
            <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We guide you through every step of the USPTO trademark registration process, from initial consultation to final registration.
            </p>
          </div>

          <div className="relative">
            {/* Timeline Line */}
            <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-blue-900 via-amber-500 to-blue-900"></div>

            <div className="space-y-12">
              {mockData.process.map((step, index) => (
                <div
                  key={index}
                  className={`flex flex-col lg:flex-row items-center gap-8 ${
                    index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  }`}
                >
                  <div className="lg:w-1/2">
                    <Card
                      className={`p-6 shadow-lg hover:shadow-xl transition-all duration-300 ${
                        index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'
                      }`}
                    >
                      <div className="text-5xl font-bold text-amber-500 mb-3">
                        {step.step}
                      </div>
                      <h3 className="text-2xl font-bold text-blue-900 mb-3">
                        {step.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {step.description}
                      </p>
                    </Card>
                  </div>

                  {/* Timeline Node */}
                  <div className="relative flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-900 to-amber-500 rounded-full flex items-center justify-center shadow-lg z-10 relative">
                      <div className="w-8 h-8 bg-white rounded-full"></div>
                    </div>
                  </div>

                  <div className="lg:w-1/2"></div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-16 bg-gradient-to-r from-amber-500 to-amber-600 rounded-2xl p-8 md:p-12 text-center text-white">
            <h3 className="text-3xl font-bold mb-4">
              Average Timeline: 8-12 Months to Registration
            </h3>
            <p className="text-lg mb-6 max-w-3xl mx-auto">
              While the USPTO process takes time, we ensure every step is handled efficiently and professionally. You'll receive regular updates throughout the entire process.
            </p>
            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-2">Immediate</div>
                <p className="text-sm">Filing Receipt & Serial Number</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-2">3-4 Months</div>
                <p className="text-sm">Examiner Review & Response</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-4">
                <div className="text-2xl font-bold mb-2">8-12 Months</div>
                <p className="text-sm">Final Registration Certificate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
